<statistics-has-sample-msg></statistics-has-sample-msg>
<page-header icon="fas fa-download"
             [header]="'Most Downloads' | translate"
             [subHeader]="'View data for the selected period.' | translate"
             [panelClass]="(domain | isStatsSampleData) ? 'mt-1' : ''">
    <page-header-content>
        <div class="d-flex align-items-center justify-content-end">
            <csv-export-button [monDisabled]="domain | isStatsSampleData" [exports]="exports"></csv-export-button>
            <date-picker [monEnableComparisonRange]="true"
                             [(date)]="date"
                             [monDateFormat]="dateFormat"
                             [monValidateStartDateCb]="validateDate"
                             [monValidateEndDateCb]="validateDate"
                             (comparisonUpdate)="updateCompareDate($event)"
                             (dateChange)="updateDateRange()">
            </date-picker>
            <table-search (getPage)="onSearch($event)"
                            [model]="search"
                            [minSearchLength]="'3'"></table-search>
        </div>
    </page-header-content>
</page-header>
<div class="card panel-monsido-card">
    <div class="card-body">
        <mon-spinner [loading]="loading">
            <div class="row">
                <div class="col-lg-48 px-md-12">
                    <mon-chart-horizontal-bar [data]="chartData"
                                              [labels]="chartLabels"
                                              [series]="chartSeries"
                                              [options]="chartOptions"
                                              [override]="chartOverride">
                    </mon-chart-horizontal-bar>
                </div>
            </div>

            <table-container-pager
                    *ngIf="comparisonEnabled"
                    [noResultMessage]="noDownloadsResultMessage"
                    [collection]="downloads"
                    [page]="page"
                    [pageSize]="pageSize"
                    (onPageChange)="onPageChangeLocal($event)"
                    [progress]="loading"
                    class="table-pager-without-page-size"
            >
                <table class="table table-hover table-fixed">
                    <thead>
                    <tr>
                        <th class="col-sm-4 col-md-4" translate>URL</th>
                        <th class="col-sm-4 col-md-6 text-center">
                            <span translate>Unique downloads</span><br>
                            <span class="text-grey">
                                ({{totalUniqueDownloads | monNumber}})
                            </span>
                        </th>
                        <th  class="col-sm-3 col-md-3 text-right" *ngIf="comparisonEnabled">
                            <span translate>Unique downloads (comp.)</span><br/>
                            <span class="invisible">&nbsp;</span>
                        </th>
                        <th class="col-sm-4 col-md-2 text-right">
                            <span translate>Downloads</span><br/>
                            <span class="invisible">&nbsp;</span>
                        </th>
                        <th  class="col-sm-3 col-md-3 text-right" *ngIf="comparisonEnabled">
                            <span translate>Downloads (comp.)</span><br/>
                            <span class="invisible">&nbsp;</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let download of downloads">
                        <td class="text-ellipsis text-v-middle">
                            <statistics-url-title [title]="download.title" [url]="download.url"></statistics-url-title>
                        </td>
                        <td class="text-v-middle">
                            <statistics-visits *ngIf="summary.visits"
                                               visits="{{ download.downloads }}"
                                               totalVisits="{{summary.visits}}">
                            </statistics-visits>
                        </td>
                        <td class="text-v-middle text-right table-comparison-cell" *ngIf="comparisonEnabled">
                            {{ download.compare?.unique_downloads }}
                        </td>
                        <td class="text-v-middle text-right">
                            {{download.pageviews}}
                        </td>
                        <td class="text-v-middle text-right table-comparison-cell" *ngIf="comparisonEnabled">
                            {{download.compare?.pageviews}}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </table-container-pager>

            <table-container-pager
                *ngIf="!comparisonEnabled"
                [noResultMessage]="noDownloadsResultMessage"
                [collection]="downloads"
                [page]="page"
                [pageSize]="pageSize"
                (onPageChange)="onPageChangeLocal($event)"
                (onPerPageChange)="onPageSizeChange($event)"
                [progress]="loading"
                class="table-pager-without-page-size"
            >
                <table class="table table-hover table-fixed">
                    <thead>
                    <tr>
                        <th class="col-sm-4 col-md-4" translate>URL</th>
                        <th class="col-sm-4 col-md-6 text-center">
                            <span translate>Unique downloads</span><br>
                            <span class="text-grey">
                                ({{totalUniqueDownloads | monNumber}})
                            </span>
                        </th>
                        <th class="col-sm-4 col-md-2 text-right">
                            <span translate>Downloads</span><br/>
                            <span class="invisible">&nbsp;</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let download of downloads">
                        <td class="text-ellipsis text-v-middle">
                            <statistics-url-title [title]="download.title" [url]="download.url"></statistics-url-title>
                        </td>
                        <td class="text-v-middle">
                            <statistics-visits *ngIf="summary.visits"
                                               visits="{{ download.downloads }}"
                                               totalVisits="{{summary.visits}}">
                            </statistics-visits>
                        </td>
                        <td class="text-v-middle text-right">
                            {{download.pageviews}}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </table-container-pager>
        </mon-spinner>
    </div>
</div>